/**
 * Domain Registry
 * 
 * Domains are workspace contexts in Mabel.
 * Each domain has its own widget layout that users can customize.
 */

export const DOMAINS = {
  hub: {
    id: 'hub',
    name: 'Hub',
    description: 'Your command center',
    icon: 'Sparkles',
    color: '#3D9A8B', // Mabel teal
    defaultEnabled: true,
    order: 1,
    canDisable: false, // Hub is always available
  },
  
  tasks: {
    id: 'tasks',
    name: 'Tasks',
    description: 'Get things done',
    icon: 'CheckSquare',
    color: '#3D9A8B', // Mabel teal
    defaultEnabled: true,
    order: 2,
    canDisable: true,
  },
  
  kitchen: {
    id: 'kitchen',
    name: 'Kitchen',
    description: 'Meals and cooking',
    icon: 'UtensilsCrossed',
    color: '#F97316', // Orange
    defaultEnabled: true,
    order: 3,
    canDisable: true,
  },

  money: {
    id: 'money',
    name: 'Money',
    description: 'Bills and budget',
    icon: 'Wallet',
    color: '#10B981', // Emerald
    defaultEnabled: true,
    order: 4,
    canDisable: true,
  },
  
  // Future domains (disabled by default)
  goals: {
    id: 'goals',
    name: 'Goals',
    description: 'Dreams and direction',
    icon: 'Compass',
    color: '#8B5CF6', // Purple
    defaultEnabled: false,
    order: 5,
    canDisable: true,
  },
  
  wellbeing: {
    id: 'wellbeing',
    name: 'Wellbeing',
    description: 'Health and wellness',
    icon: 'Heart',
    color: '#EC4899', // Pink
    defaultEnabled: false,
    order: 6,
    canDisable: true,
  },
  
  rooms: {
    id: 'rooms',
    name: 'Rooms',
    description: 'Home organization',
    icon: 'Home',
    color: '#6366F1', // Indigo
    defaultEnabled: false,
    order: 7,
    canDisable: true,
  },
};

/**
 * Default widget layouts per domain
 * These are used when user hasn't customized
 */
export const DOMAIN_DEFAULTS = {
  hub: [
    'install',
    'todaysFocus',
    'roadmapCard',
    'tasksCard',
    'kitchenCard',
    'moneyCard',
    'recentWins',
    'review',
  ],
  
  tasks: [
    'taskFilters',
    'taskList',
  ],
  
  kitchen: [
    'tonightCard',
    'expiringCard',
    'shoppingCard',
    'pantryCard',
    'mealsCard',
    'foodLogCard',
  ],

  money: [],
  
  goals: [
    'goals',
  ],
  
  wellbeing: [
    'sleep',
    'hydration',
  ],
  
  rooms: [],
};

// ============================================
// HELPER FUNCTIONS
// ============================================

/**
 * Get all domains sorted by order
 */
export const getAllDomains = () => {
  return Object.values(DOMAINS).sort((a, b) => a.order - b.order);
};

/**
 * Get default enabled domains
 */
export const getDefaultEnabledDomains = () => {
  return Object.values(DOMAINS)
    .filter(domain => domain.defaultEnabled)
    .sort((a, b) => a.order - b.order)
    .map(domain => domain.id);
};

/**
 * Get a domain by ID
 */
export const getDomain = (domainId) => {
  return DOMAINS[domainId] || null;
};

/**
 * Get default widget layout for a domain
 */
export const getDefaultLayout = (domainId) => {
  return DOMAIN_DEFAULTS[domainId] || [];
};
